import React from 'react';
import './ContactForm.css';

function ContactForm({ 
  mode, // 'add' or 'edit'
  contact, 
  onChange, 
  onSubmit, 
  onCancel 
}) {
  const isEdit = mode === 'edit';
  
  return (
    <form className="contact-form" onSubmit={onSubmit}>
      <h3>{isEdit ? 'Edit Contact' : 'Add New Contact'}</h3>
      
      <div className="form-row">
        <input
          type="text"
          placeholder="First Name *"
          value={contact.first_name}
          onChange={(e) => onChange({...contact, first_name: e.target.value})}
          required
        />
        <input
          type="text"
          placeholder="Last Name *"
          value={contact.last_name}
          onChange={(e) => onChange({...contact, last_name: e.target.value})}
          required
        />
      </div>
      
      <div className="form-row">
        <input
          type="email"
          placeholder="Email"
          value={contact.email || ''}
          onChange={(e) => onChange({...contact, email: e.target.value})}
        />
        <input
          type="tel"
          placeholder="Phone"
          value={contact.phone || ''}
          onChange={(e) => onChange({...contact, phone: e.target.value})}
        />
      </div>
      
      <div className="form-row">
        <input
          type="text"
          placeholder="City"
          value={contact.city || ''}
          onChange={(e) => onChange({...contact, city: e.target.value})}
        />
        <input
          type="text"
          placeholder="Country"
          value={contact.country || ''}
          onChange={(e) => onChange({...contact, country: e.target.value})}
        />
      </div>
      
      <input
        type="text"
        placeholder="Source (how you met them)"
        value={contact.source || ''}
        onChange={(e) => onChange({...contact, source: e.target.value})}
      />
      
      <div className="form-actions">
        <button type="submit" className="save-btn">
          {isEdit ? 'Save Changes' : 'Save Contact'}
        </button>
        <button type="button" onClick={onCancel} className="cancel-btn">
          Cancel
        </button>
      </div>
    </form>
  );
}

export default ContactForm;

